$(document).ready(function(){

    /* HEADER AND NAV */

    // Check for click events on the navbar burger icon
    $(".navbar-burger").click(function() {
        // Toggle the "is-active" class
        $(".navbar-burger").toggleClass("is-active");
        $(".site-modal-menu").toggleClass("is-active");
        $(".navbar-wrapper").toggleClass("is-over-menu");
        $("html").toggleClass("is-clipped");
    });

    //Close navigation with ESC key
    $(document).keyup(function(e) {
        var $burger = $(".navbar-burger")
        if (e.keyCode === 27) {
            if( $burger.hasClass('is-active') ){
                $burger.click(); // esc
            }
            $("html").removeClass('is-clipped');
            $(".site-navbar").removeClass("is-over-menu");
        }
    });

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.navbar-wrapper').outerHeight();

    $(window).scroll(function(event){
        didScroll = true;
        if( $(window).scrollTop() > 0 ) {
            $('.navbar-wrapper').addClass('nav-on-scroll');
        } else {
            $('.navbar-wrapper').removeClass('nav-on-scroll');
        }
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();
        
        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;
        
        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
            $('.navbar-wrapper').removeClass('nav-visible').addClass('nav-hide');
        } else {
            // Scroll Up
            if(st + $(window).height() < $(document).height()) {
                $('.navbar-wrapper').removeClass('nav-hide').addClass('nav-visible');
            }
        }
        
        lastScrollTop = st;
    }

    //Smoothscroll
    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('.mobile-accordion__button')
        .click(function(event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();

                $('html, body').animate({
                    scrollTop: target.offset().top - 100
                }, 1000);
            }
        }
    });

    // Message modal
    var modalClosed = getCookie("modalclosed");
    // console.log(modalClosed);
    if( modalClosed == 'yes' ){
        $('#modalMessage').removeClass('is-active');
    }
    $(".site-modal-message .delete").click(function() {
        $(".site-modal-message").removeClass("is-active");
        setCookie("modalclosed", "yes", 7); // 7 days
    });

    // Message notification
    $(".notification-message .delete").click(function() {
        $(this).parents('.notification-message').toggleClass("is-hidden");
    });

    // Message notification: Autodetect Lang
    var notificationAutodetectLangClosed = getCookie("notificationAutodetectLangClosed");
    var notificationAutodetectLang = $('#notificationAutodetectLang');
    // console.log(notificationAutodetectLangClosed);
    if( notificationAutodetectLangClosed != 'yes' ){
        notificationAutodetectLang.removeClass('is-hidden');
    }
    notificationAutodetectLang.find(".delete").click(function() {
        notificationAutodetectLang.addClass("is-hidden");
        setCookie("notificationAutodetectLangClosed", "yes", 1); // 1 day
    });


    //profile builder minor fix
    if( $('.wppb-description-delimiter').is(':empty') ){
        $('.wppb-description-delimiter').hide();
    }

    //Share popups
    $(".js-social-share").on("click", function(e) {
        e.preventDefault();
        windowPopup($(this).attr("href"), 800, 700);
    });

    //Style WP QUIZ PRO Prerequisites
    if( $('.wpProQuiz_prerequisite').length ){
        setTimeout(function(){
            var prerequisites = $('.wpProQuiz_prerequisite p span').text();
            $('.wpProQuiz_prerequisite p span').html('<ul><li>' + prerequisites.replace(/,/g,'</li><li>') + '</li></ul>');
        }, 1500);
    }

    //Fix: Find font awesome class in learndash-certificate-verify-share-add-on and replace with font awesome pro class
    $('.ld-cvss-social-buttons-list .fa').removeClass('fa').addClass('fab');

    //FIXS Polylang
    if( $('.logged-in .pll-switcher-select').length ){
        
        //Add update user lang parameter in Polylang language switcher for logged in users
        $(".logged-in .pll-switcher-select > option").each(function() {
            var new_url = updateQueryStringParameter(this.value, 'update-user-lang', 1);
            $(this).attr("value", new_url);
        });
        
    }

    // make tables responsive
    $('.ld-tab-content table, .content table').wrap('<div class="table-container"></div>');

    
    // Mobile accordion
    var isMobile = window.matchMedia("only screen and (max-width: 769px)").matches;
    if (isMobile) {
        // hide the panes in mobile
        $('.mobile-accordion__pane').removeClass('is-hidden-mobile').hide();
        $('.column-select-method').addClass('is-hidden-mobile');
        // Click function
        $('.mobile-accordion .mobile-accordion__button').click(function(e){
            e.preventDefault();
            //target
            var activePane = $(this).attr('href');
            //Reseteo todos los otros paneles
            $(this).parents('.mobile-accordion').find('.mobile-accordion__pane').slideUp();
            $(this).parents('.mobile-accordion').find('.mobile-accordion__button-plus').removeClass('is-hidden');
            $(this).parents('.mobile-accordion').find('.mobile-accordion__button-minus').addClass('is-hidden');
            $(this).parents('.mobile-accordion').find('.column-select-method').addClass('is-hidden-mobile');
            //Al que le hice click lo cierro si está visible y lo abro en caso contrario
            if( $(activePane).is(':visible') ){
                $(this).find('.mobile-accordion__button-plus').removeClass('is-hidden');
                $(this).find('.mobile-accordion__button-minus').addClass('is-hidden');
                $(this).parent().parent().find('.column-select-method').addClass('is-hidden-mobile');
                $(activePane).slideUp();
            } else {
                $(this).find('.mobile-accordion__button-plus').addClass('is-hidden');//oculto "ver mas"
                $(this).find('.mobile-accordion__button-minus').removeClass('is-hidden');//muestro "cerrar"
                $(this).parent().parent().find('.column-select-method').removeClass('is-hidden-mobile');//muestro CTA "select method"
                $(activePane).slideDown();
            }
        });
    }

    // General accordion
    $('.accordion .accordion__item-title').click(function(e){
        e.preventDefault();
        //target
        var activeItem = $(this).parent('.accordion__item');
        //Al que le hice click lo cierro si está visible y lo abro en caso contrario
        if( activeItem.hasClass('is-active') ){
            activeItem.removeClass('is-active');
        } else {
            //Reseteo todos los otros paneles
            activeItem.parents('.accordion').find('.accordion__item').removeClass('is-active');
            //abro el clickqueado
            activeItem.addClass('is-active');
        }
    });
    
});

if (document.addEventListener) {
    window.addEventListener('pageshow', function (event) {

        var pll_language = getCookie('pll_language');
        //console.log('cookie: '+pll_language);

        var current_locale = $('html').attr('lang');
        var current_lang_slug = current_locale.slice(0,-3);
        //console.log('current lang slug: '+current_lang_slug);

        if (event.persisted || window.performance && 
            window.performance.navigation.type == 2) 
        {

            //fix en switcher al volver atrás
            var selected = $(".pll-switcher-select option[selected]").val();
            $(".pll-switcher-select").val(selected);

            //Fix: fuerzo el reload cuando el usuario vuelve hacia atrás intentando cambiar su idioma. Solo se puede desde el dropdown o editando perfil.
            if( $('body').hasClass('logged-in') ){
                if( pll_language !== current_lang_slug ){
                    location.reload();
                }
            }

        }
    },
   false);
}

function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
}

function windowPopup(url, width, height) {
    // Calculate the position of the popup so
    // it’s centered on the screen.
    var left = (screen.width / 2) - (width / 2),
        top = (screen.height / 2) - (height / 2);
  
    window.open(
      url,
      "",
      "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
    );
}

/* Cookies */
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}


function copyToClipboard(elem) {
    // create hidden text element, if it doesn't already exist
    var targetId = "_hiddenCopyText_";
    var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
    var origSelectionStart, origSelectionEnd;
    if (isInput) {
        // can just use the original source element for the selection and copy
        target = elem;
        origSelectionStart = elem.selectionStart;
        origSelectionEnd = elem.selectionEnd;
    } else {
        // must use a temporary form element for the selection and copy
        target = document.getElementById(targetId);
        if (!target) {
            var target = document.createElement("textarea");
            target.style.position = "absolute";
            target.style.left = "-9999px";
            target.style.top = "0";
            target.id = targetId;
            document.body.appendChild(target);
        }
        target.textContent = elem.textContent;
    }
    // select the content
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);
    
    // copy the selection
    var succeed;
    try {
            succeed = document.execCommand("copy");
    } catch(e) {
        succeed = false;
    }
    // restore original focus
    if (currentFocus && typeof currentFocus.focus === "function") {
        currentFocus.focus();
    }
    
    if (isInput) {
        // restore prior selection
        elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
        // clear temporary content
        target.textContent = "";
    }
    return succeed;
}

function copyToClipboardMsg(elem, msgElem) {
    var succeed = copyToClipboard(elem);
    var msg;
    if (!succeed) {
        msg = "Tu navegador no permite el copiado. Selecciona y presiona Ctrl+c."
    } else {
        msg = "Texto copiado al portapapeles."
    }
    if (typeof msgElem === "string") {
        msgElem = document.getElementById(msgElem);
    }
    msgElem.innerHTML = msg;
    msgElem.style.display = 'block';
    setTimeout(function() {
        msgElem.innerHTML = "";
        msgElem.style.display = 'none';
    }, 2000);
}